<!-- 公共组件：抽屉电梯组件 -->
<template>
  <el-drawer
    ref="drawerRef"
    class="elevator-drawer"
    :visible.sync="drawerVisible"
    :size="size"
    :wrapperClosable="wrapperClosable"
    v-bind="$attrs"
    v-on="$listeners"
    :style="drawerStyle"
  >
    <template slot="title">
      <slot name="title"><span>{{ title }}</span></slot>
    </template>

    <el-container class="drawer-container" :style="{height: containerHeight}">
      <el-container class="drawer-body-container">
        <el-aside v-if="elevatorData.length" class="left-container" :width="elevatorWidth + 'px'">
          <ul class="floor-list">
            <li v-for="it in elevatorData" :key="it.className">
              <el-button type="link" @click="scrollTo(it.className)">{{ it.title }}</el-button>
            </li>
          </ul>
        </el-aside>
        <el-main class="right-container" ref="scrollContainer">
          <slot></slot>
        </el-main>
      </el-container>
      <el-footer v-if="$slots.footer" class="drawer-footer" :style="footerStyle">
        <slot name="footer"></slot>
      </el-footer>
    </el-container>
  </el-drawer>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    size: {
      type: String,
      default: '850px',
    },
    elevatorWidth: {
      type: Number,
      default: 120,
    },
    wrapperClosable: {
      type: Boolean,
      default: false,
    },
    // 左侧电梯数据
    elevatorData: {
      type: Array,
      default: () => [],
    },
    top: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    headerHeight: {
      type: Number,
      default: 73,
    },
  },
  data() {
    return {};
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    drawerStyle() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
      }
    },
    containerHeight() {
      return `calc(100vh - ${this.top}px - ${this.headerHeight}px)`;
    },
    footerStyle() {
      const paddingLeft = this.elevatorData.length ? this.elevatorWidth : 20;
      return {
        paddingLeft: paddingLeft + 'px'
      };
    },
  },
  methods: {
    scrollTo(className) {
      const container = this.$refs.scrollContainer.$el;
      let el = container.querySelector(`.${className}`);
      if (!el) {
        return console.error(`未找到class为${className}的元素`);
      };
      let clientHeight = container.clientHeight;
      let scrollHeight = container.scrollHeight;
      if(scrollHeight > clientHeight){
        let scrollTop = 0;
        const isFirstFloor = this.elevatorData.findIndex((item) => item.className === className) === 0;
        if (!isFirstFloor) {
          while(el != null && el != container) {
            scrollTop += el.offsetTop;
            el = el.offsetParent;
          }
        }

        container.scrollTo({
          top: scrollTop,
          behavior: "smooth"
        });
      }
    },
    closeDrawer() {
      this.$refs.drawerRef.closeDrawer();
    },
  },
};
</script>

<style lang="scss" scoped>
.elevator-drawer {
  ::v-deep .el-drawer__header {
    font-size: 18px;
    padding-bottom: 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #dcdfe6;
  }
}
.drawer-container {
  .drawer-body-container {
    overflow: auto;
  }
  .left-container {
    border-right: 1px solid #dcdfe6;
    padding-top: 10px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    .floor-list {
      text-align: center;
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        line-height: 60px;
      }
      ::v-deep .el-button--link {
        font-size: 14px;
      }
    }
  }
  .right-container {
    height: 100%;
    position: relative;
  }
  .drawer-footer {
    border-top: 1px solid #dcdfe6;
    line-height: 60px;
    padding-left: 120px;
  }
}
</style>
